import axios from "axios";
import {handleLogout} from "./services/Logout";

const instance = axios.create({
    // baseURL: 'http://localhost:8888/'
    baseURL: 'https://pigwin.tech/'
    // baseURL: 'https://poker-backend-express-production.up.railway.app/'
});

export const setupInterceptors = (dispatch, navigate) => {
    instance.interceptors.response.use(
        response => response,
        error => {
            console.log(error);

            const status = error?.response?.status;

            // Logout only on 401 (token expired / unauthenticated)
            // 403 = forbidden (permission denied) — do NOT logout
            // Don't logout on 401 from the login page itself (wrong credentials)
            const isLoginRequest = error?.config?.url?.includes('/auth/login');
            if (status === 401 && !isLoginRequest) {
                handleLogout(dispatch, navigate);
            }

            return Promise.reject(error);
        }
    );
};

export default instance;